import { OpacityPanel } from 'markerjs2';
import { Subscription } from 'rxjs';
import { SliderInputComponent } from '../../../../../Common/Forms/components/SliderInput/slider-input.component';


export class ChartAnnotationOpacityPanel extends OpacityPanel {

    opacityPanel: SliderInputComponent;
    currOpacity: number;
    subscription: Subscription;

    constructor(
        title: string,
        fonts: number[],
        currentOpacity?: number,
        icon?: string,
        component?: SliderInputComponent
    ) {
        super(
            title,
            fonts,
            currentOpacity,
            icon
        );
        this.currOpacity = currentOpacity;
        this.opacityPanel = component;
    }

    getUi(): HTMLDivElement {
        this.opacityPanel.writeValue(this.currOpacity * 100);
        const numberInputElement = this.opacityPanel.containerElement;
        const minMaxLabels = numberInputElement.querySelectorAll('.agpr-sliderInput-minMaxLabel');
        (Array.from(minMaxLabels) as HTMLElement[]).forEach(x => {
            x.style.color = '#2c353e';
            x.style.position = 'relative';
            x.style.top = '6px';
        });
        this.subscription = this.opacityPanel.changes.subscribe(x => {
            if (this.onOpacityChanged) {
                this.onOpacityChanged(x / 100);
            }
        });
        return this.opacityPanel.containerElement;
    }
}
